import React from 'react';
import type { IconComponentProps } from '@/types/components';

export const EyeOffFilled: React.FC<IconComponentProps> = ({ className }) => (
  <svg
    className={className}
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M0.735361 1.87178C0.421547 1.55797 0.421547 1.04917 0.735361 0.735361C1.04917 0.421546 1.55797 0.421546 1.87178 0.735361L4.43256 3.29614C5.47401 2.61311 6.68612 2.10714 8 2.10714C9.67174 2.10714 11.1787 2.92627 12.379 3.887C13.5858 4.85285 14.5402 6.00781 15.1174 6.78269L15.1218 6.78865C15.372 7.13453 15.5 7.5666 15.5 8C15.5 8.4334 15.372 8.86544 15.1218 9.21131L15.1174 9.21735C14.6178 9.88814 13.8354 10.8437 12.8513 11.715L15.2646 14.1283C15.5784 14.4421 15.5784 14.9508 15.2646 15.2646C14.9508 15.5784 14.4421 15.5784 14.1283 15.2646L0.735361 1.87178ZM10.176 9.03955C10.6041 8.14344 10.4471 7.03761 9.70481 6.29537C8.96257 5.55312 7.85674 5.39608 6.96063 5.82422L10.176 9.03955ZM0.882636 6.78269C1.20719 6.34691 1.65108 5.79095 2.19208 5.216L10.3475 13.3715C9.61704 13.6915 8.82876 13.8929 8 13.8929C6.32826 13.8929 4.82127 13.0738 3.62094 12.113C2.41421 11.1472 1.45975 9.99219 0.882636 9.21731L0.87819 9.21135C0.627988 8.86547 0.5 8.4334 0.5 8C0.5 7.5666 0.628029 7.13456 0.878231 6.78869L0.882636 6.78269Z"
      fill="currentColor"
    />
  </svg>
);
